import { Injectable } from '@angular/core';

@Injectable()
export class StatePersistService {

    public get<T>(token: string): T {
        const settings = localStorage.getItem(token);

        return settings
            ? JSON.parse(settings)
            : settings;
    }

    public set<T>(token: string, gridConfig): void {
        localStorage.setItem(token, JSON.stringify(gridConfig));
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/services/state-persist.service.ts